import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cascading Province -> Regency -> District -> Village picker. Calls onVillageChange(villageId).
const RegionCascade = ({ onVillageChange }) => {
  const [prov, setProv] = useState([]);
  const [reg, setReg] = useState([]);
  const [dist, setDist] = useState([]);
  const [vil, setVil] = useState([]);
  const [p, setP] = useState('');
  const [r, setR] = useState('');
  const [d, setD] = useState('');
  const [v, setV] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/regions`, { params: { level: 'province' } }).then((x) => setProv(x.data)).catch(() => {});
  }, []);
  useEffect(() => {
    setR(''); setD(''); setV(''); setReg([]); setDist([]); setVil([]); onVillageChange && onVillageChange('');
    if (p) axios.get(`${API_URL}/api/regions`, { params: { level: 'regency', parent_id: p } }).then((x) => setReg(x.data)).catch(() => {});
  }, [p]);
  useEffect(() => {
    setD(''); setV(''); setDist([]); setVil([]); onVillageChange && onVillageChange('');
    if (r) axios.get(`${API_URL}/api/regions`, { params: { level: 'district', parent_id: r } }).then((x) => setDist(x.data)).catch(() => {});
  }, [r]);
  useEffect(() => {
    setV(''); setVil([]); onVillageChange && onVillageChange('');
    if (d) axios.get(`${API_URL}/api/regions`, { params: { level: 'village', parent_id: d } }).then((x) => setVil(x.data)).catch(() => {});
  }, [d]);

  const cls = 'w-full px-3 py-2.5 rounded-xl border border-stone-200 focus:border-emerald-500 outline-none font-body text-sm';
  return (
    <div className="grid grid-cols-2 gap-3">
      <select data-testid="cascade-province" value={p} onChange={(e) => setP(e.target.value)} className={cls}>
        <option value="">Pilih Provinsi</option>
        {prov.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
      </select>
      <select data-testid="cascade-regency" value={r} onChange={(e) => setR(e.target.value)} disabled={!p} className={cls}>
        <option value="">Pilih Kabupaten/Kota</option>
        {reg.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
      </select>
      <select data-testid="cascade-district" value={d} onChange={(e) => setD(e.target.value)} disabled={!r} className={cls}>
        <option value="">Pilih Kecamatan</option>
        {dist.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
      </select>
      <select data-testid="cascade-village" value={v} onChange={(e) => { setV(e.target.value); onVillageChange && onVillageChange(e.target.value); }} disabled={!d} className={cls}>
        <option value="">Pilih Desa/Kelurahan</option>
        {vil.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
      </select>
    </div>
  );
};

export default RegionCascade;
